import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AdSlot from "@/components/AdSlot";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <AdSlot placement="header" className="py-3" />
      <main className="flex-1">
        <Outlet />
      </main>
      <AdSlot placement="footer" className="py-3" />
      <Footer />
    </div>
  );
}
